import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import React from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

import '@total-typescript/ts-reset';
import 'dayjs/locale/sv';
import '@/lib/assets/styles/react-calendar.scss';
import '@/lib/i18n';
import '@/lib/utils/sentry';
import { PostHogProvider } from 'posthog-js/react';

import App from './app';
import './index.css';

dayjs.locale('sv');
dayjs.extend(calendar);

const ConditionalPosthogProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  if (
    import.meta.env.VITE_APP_POSTHOG_HOST &&
    import.meta.env.VITE_APP_POSTHOG_KEY
  ) {
    return (
      <PostHogProvider
        apiKey={import.meta.env.VITE_APP_POSTHOG_KEY}
        options={{
          api_host: import.meta.env.VITE_APP_POSTHOG_HOST,
        }}
      >
        {children}
      </PostHogProvider>
    );
  }
  return <>{children}</>;
};

const container = document.getElementById('root') as HTMLElement;
createRoot(container).render(
  <ConditionalPosthogProvider>
    <App />
  </ConditionalPosthogProvider>,
);

reportWebVitals();
